var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgThumbsUp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 18.3334H3.33366C2.89163 18.3334 2.46771 18.1578 2.15515 17.8452C1.84259 17.5326 1.66699 17.1087 1.66699 16.6667V10.8334C1.66699 10.3913 1.84259 9.9674 2.15515 9.65484C2.46771 9.34228 2.89163 9.16669 3.33366 9.16669H5.83366M11.667 7.50002V4.16669C11.667 3.50365 11.4036 2.86776 10.9348 2.39892C10.4659 1.93008 9.83003 1.66669 9.16699 1.66669L5.83366 9.16669V18.3334H15.2337C15.6356 18.3379 16.0256 18.197 16.3319 17.9367C16.6382 17.6764 16.8401 17.3141 16.9003 16.9167L18.0503 9.41669C18.0866 9.17782 18.0705 8.93392 18.0031 8.7019C17.9357 8.46987 17.8187 8.25527 17.6602 8.07295C17.5017 7.89063 17.3054 7.74496 17.085 7.64603C16.8645 7.54711 16.6252 7.49728 16.3837 7.50002H11.667Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumbsUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumbs-up.78dd4afd.svg";
export { ForwardRef as ReactComponent };